import {DragDropHandler, useDragDrop} from "./drag-drop-context";
import {classNames} from "utils/helpers";
import "./drop-zone.less"
import { PropsWithChildren, useEffect, useRef } from "react";

interface DropProps {
  zoneId: string
  className?: string
  onDragOver?: DragDropHandler
  onDragExit?: DragDropHandler
  onDrop?: DragDropHandler
  onClick?: () => void
}

export function DropZone(props: PropsWithChildren<DropProps>) {
  const {zoneId: zoneId, className, children, onDrop, onDragExit, onDragOver} = props;
  const ref = useRef<HTMLDivElement>();
  const dragDrop = useDragDrop();
  
  useEffect(() => {
    dragDrop.addTarget({
      id: zoneId,
      isDraggedOver: false,
      getRect: () => ref.current?.getBoundingClientRect() ?? new DOMRect(),
      onUserDragOver: onDragOver,
      onUserDragExit: onDragExit,
      onUserDrop: onDrop,
    })
    return () => {
      dragDrop.removeTarget(zoneId);
    }
  }, [zoneId, onDragOver, onDragExit, onDrop])

  return <div
    ref={ref as any}
    className={classNames("drop-zone", className)}
    onClick={props.onClick}
  >
    {children}
  </div>
}
